import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import { RoofTypeForm, RoofTypeListResponse } from "../types";
import {
  selectRoofTypeForm,
  selectRoofTypePage,
  selectRoofTypePerPage,
} from "./selector";
import { roofTypeActions } from "./slice";

let isFetchingList = false;

export function* handleGetRoofTypeList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectRoofTypePage);
    const perPage: number = yield select(selectRoofTypePerPage);

    const response: RoofTypeListResponse = yield call(
      request,
      `${API_URL}/roof-beam-type/list?page=${page}&perPage=${perPage}`,
      { method: "GET" },
    );

    const rawData = response?.data || [];
    const meta = getPaginationMeta(page, perPage, rawData, response?.meta);
    const data = rawData.filter((item) =>
      Boolean(String(item?.beamTypeDesc ?? "").trim()),
    );
    const payload = { data, meta };

    if (page === 1) {
      yield put(roofTypeActions.getRoofTypeListSuccess(payload));
    } else {
      yield put(roofTypeActions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectRoofTypePage);

    if (page === 1) {
      yield put(roofTypeActions.getRoofTypeListError(message));
    } else {
      yield put(roofTypeActions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddRoofType() {
  const form: RoofTypeForm = yield select(selectRoofTypeForm);

  try {
    yield call(request, `${API_URL}/roof-beam-type`, {
      method: "POST",
      body: JSON.stringify({
        beamTypeDesc: form.description.trim(),
        beamMaxHeight: Number(form.maxHeight),
      }),
    });

    yield put(roofTypeActions.addRoofTypeSuccess());
    yield put(roofTypeActions.getRoofTypeList());
  } catch (error) {
    yield put(roofTypeActions.addRoofTypeError((error as Error).message));
  }
}

export function* roofTypeSaga() {
  yield takeLeading(
    roofTypeActions.getRoofTypeList.type,
    handleGetRoofTypeList
  );
  yield takeLeading(
    roofTypeActions.getNextPageItems.type,
    handleGetRoofTypeList
  );
  yield takeLatest(roofTypeActions.addRoofType.type, handleAddRoofType);
}

export default roofTypeSaga;
